import React from "react";
import SimpleBar, { Props } from "simplebar-react";
//import 'simplebar/dist/simplebar.min.css';
import { useSimpleBarRefresher } from "./useSimpleBarRefresher";

type ScrollableProps = React.HTMLAttributes<HTMLElement> &
  Props & {
    maxHeight?: string | number;
    refreshAfterInstall?: number;
  };

export const Scrollable: React.FC<ScrollableProps> = ({
  refreshAfterInstall = 700,
  maxHeight,
  ...rest
}) => {
  const { ref } = useSimpleBarRefresher();
  return <SimpleBar ref={ref} style={{ maxHeight: maxHeight }} {...rest} />;
};
